import { FaqFeature, Helps } from '../models';

export const getFaqs = (helps: Helps, feature: FaqFeature) => {
  switch (feature) {
    case FaqFeature.Address:
      return helps.faqEditAddress;
    case FaqFeature.Login:
      return helps.faqLogin;
    case FaqFeature.PaymentMethods:
      return helps.faqPaymentMethods;
    case FaqFeature.Pdr:
      return helps.faqPdr;
    case FaqFeature.Reception:
      return helps.faqReception;
    case FaqFeature.TimePicker:
      return helps.timePickerHelpPages;
    case FaqFeature.Order:
      return helps.faqPages;
    default:
      return [];
  }
};
